import React from 'react';
import styled from 'styled-components';

const PurposeSection = styled.section`
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 20px;
  position: relative;
  background:
  overflow: hidden;
`;

const PurposeContainer = styled.div`
  max-width: 712px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

const Subtitle = styled.h5`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: #289E46;
`;

const Description = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #002776;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Paragraph = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #6B6B6B;
  line-height: 1.5;
  max-width: 454px;

  @media (max-width: 768px) {
    font-size: 15px;
    max-width: 100%;
  }
`;

const LeftHand = styled.img`
  position: absolute;
  left: 0;
  bottom: -100px;
  transform: rotate(115.42deg);
  width: 280px;
  opacity: 0.6;
  z-index: 1;

  @media (max-width: 768px) {
    left: -20px;
    bottom: -40px;
    width: 180px;
  }
`;

const RightHand = styled.img`
  position: absolute;
  right: 0;
  top: -100px;
  transform: rotate(-63.99deg);
  width: 390px;
  opacity: 0.6;
  z-index: 1;

  @media (max-width: 768px) {
    right: -40px;
    top: -40px;
    width: 220px;
  }
`;

const Logo = styled.img`
  margin-top: 16px;
  width: 44px;
  height: auto;
`;

export default function PurposeBanner() {
  return (
    <PurposeSection>
      <LeftHand src="/images/maoesquerda.png" alt="Mão esquerda" />
      <RightHand src="/images/maodireita.png" alt="Mão direita" />
      <PurposeContainer>
        <Subtitle>A NAÇÃO SAÚDE NASCEU COM UM PROPÓSITO CLARO</Subtitle>
        <Description>
          Liderar um movimento de bem-estar e saúde que torne o cuidado acessível, prático e humano.
        </Description>
        <Paragraph>
          Somos uma alternativa real ao modelo tradicional, conectando pessoas a soluções completas: sem burocracia e com impacto. Acreditamos que toda vida importa (e que ninguém deve ficar sem acesso ao que é essencial para viver melhor).
        </Paragraph>
        <Logo src="/images/logo-header-nacao.png" alt="Logo Nação Saúde" />
      </PurposeContainer>
    </PurposeSection>
  );
}
